"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPortal = void 0;
var portalBase_1 = require("./portalBase");
var authenticationEndpoints_1 = require("./endpoints/authenticationEndpoints");
var companyEndpoints_1 = require("./endpoints/companyEndpoints");
var genericEndpoints_1 = require("./endpoints/genericEndpoints");
var pickerEndpoints_1 = require("./endpoints/pickerEndpoints");
var productEndpoints_1 = require("./endpoints/productEndpoints");
var publicEndpoints_1 = require("./endpoints/publicEndpoints");
var userEndpoints_1 = require("./endpoints/userEndpoints");
var userMeEndpoints_1 = require("./endpoints/userMeEndpoints");
exports.createPortal = function (options, extension) {
    var base = portalBase_1.createPortalBase(options);
    return __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ get access_token() {
            return base.accessors.access_token;
        },
        set access_token(val) {
            base.accessors.access_token = val;
        },
        get api_token() {
            return base.accessors.api_token;
        },
        set api_token(val) {
            base.accessors.api_token = val;
        },
        get company_name_key() {
            return base.accessors.company_name_key;
        },
        set company_name_key(val) {
            base.accessors.company_name_key = val;
        },
        get environment() {
            return base.accessors.environment;
        },
        set environment(val) {
            base.accessors.environment = val;
        },
        get portal_base_url() {
            return base.accessors.portal_base_url;
        },
        set portal_base_url(val) {
            base.accessors.portal_base_url = val;
        },
        get subdomain() {
            return base.accessors.subdomain;
        },
        set subdomain(val) {
            base.accessors.subdomain = val;
        } }, authenticationEndpoints_1.createAuthenticationEndpoints(base)), companyEndpoints_1.createCompanyEndpoints(base)), genericEndpoints_1.createGenericEndpoints(base)), pickerEndpoints_1.createPickerEndpoints(base)), productEndpoints_1.createProductEndpoints(base)), publicEndpoints_1.createPublicEndpoints(base)), userEndpoints_1.createUserEndpoints(base)), userMeEndpoints_1.createUserMeEndpoints(base)), (extension === null || extension === void 0 ? void 0 : extension(base)));
};
//# sourceMappingURL=portal.js.map